import { FlagState } from './types';
export function localStorageFlagIsEnabled(featureKey) {
    const value = window.localStorage.getItem(featureKey);
    return value === FlagState.ENABLED;
}
